import logger from "../../utils/logger";


export const validSession = () => {

    const storedData = localStorage.getItem('REACT_TOKEN_AUTH_KEY');
    if (!storedData) {
        logger.warn('No data found in REACT_TOKEN_AUTH_KEY');
        return null;
    }
    else {
        return true;
    }
};